import React from 'react';
import { Typography, Card, CardContent, Grid, CardActions, Box } from '@material-ui/core';
import { Button, IconButton } from '@mui/material';
import { AddCircleOutline, Bookmark, Height } from '@mui/icons-material';
import { AddCircleOutlined, ArrowDownward } from '@material-ui/icons';
import NewImportEmployee from './Modal/NewImportEmployee';

const CustomCard = ({
  employeeData,
  dataCard,
  handlechangeFilter,
  handleSelectedCard,
  viewEmployeeRegistration
}) => {



  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: -15 }}>
      {
        dataCard.map((data, key) => (
          <div style={{ flex: 1.8, margin: '10px' }}>
            <Card style={styles.Card}>
              <CardContent>
                <Box style={{ ...styles.Box, backgroundColor: data.color, position: 'relative' }}>
                  <Typography style={styles.TextBox}>
                    {data.number}
                  </Typography>
                  <div style={{ ...styles.customIconStyle, ...styles.circleStyle }}>
                    <Bookmark style={{ color: 'white', fontSize: 16 }} />
                  </div>
                </Box>
                <div style={styles.div}>
                  <Typography>
                    {data.type == 'Ativos' || data.type == 'Pendentes' ?
                      <>
                        <span
                          style={{
                            fontFamily: 'montserrat',
                            // fontWeight: 'bold',
                            fontSize: 16
                          }}
                        >
                          Colaboradores
                        </span>
                        <span
                          style={{
                            color: data.color,
                            fontFamily: 'montserrat',
                            fontWeight: 'bold',
                            fontSize: 16
                          }}
                        >
                          {' ' + data.title + ' '}
                        </span>
                      </>
                      :
                      <>
                        <span style={{
                          color: data.color,
                          // color: 'black',
                          fontFamily: 'montserrat',
                          fontWeight: 'bold',
                          fontSize: 16
                        }}>
                          {data.title + ''}
                        </span>
                        <span
                          style={{
                            fontFamily: 'montserrat',
                            // fontWeight: 'bold',
                            fontSize: 16
                          }}
                        >
                          &nbsp; cadastrados
                        </span>
                      </>
                    }
                  </Typography>
                </div>
              </CardContent>
              <CardActions disableSpacing>
                <Button
                  size="small"
                  style={{
                    ...styles.customButtonStyle,
                    borderColor: data.color,
                    color: data.color,
                    display: 'flex', // Necessário para usar justifyContent
                  }}
                  onClick={() => {
                    let event = {
                      target: {
                        value: data.value
                      }
                    }
                    handleSelectedCard(event, 'status')
                  }}
                >
                  <AddCircleOutline style={{ marginRight: '5px' }} />
                  <div style={{ flex: 1, textAlign: 'center' }}>ver  {data.value}</div>
                  <div style={{ flex: 0.3 }} />
                </Button>
              </CardActions>
            </Card>
          </div>
        ))
      }
      <div style={{ flex: 2.8, margin: '10px' }}>
        <Card style={styles.Card}>
          <CardContent>
            <Typography color="textSecondary" style={styles.TypographyCadastro}>
              <div style={styles.divCadastro} >
                Cadastrar
              </div>
              <div style={{ margin: '0 3px' }}></div>
              <div style={{ color: '#20314a', fontFamily: 'montserrat' }}>
                Colaboradores
              </div>
            </Typography>
            <Box style={{ ...styles.BoxIndividual }}>
              <Button
                variant="outlined"
                startIcon={<AddCircleOutlined />}
                style={{ ...styles.ButtonIndividual }}
                onClick={viewEmployeeRegistration.handleViewRegistrationReset}
              >
                Individual
              </Button>
            </Box>
            <Box style={{ ...styles.BoxImport }}>
              <Button
                variant="outlined"
                startIcon={<ArrowDownward />}
                style={{ ...styles.Import }}
                onClick={viewEmployeeRegistration.handleImportEmployee}
              >
                Importar em massa (xls)
              </Button>
            </Box>
          </CardContent>

        </Card>
      </div>
      <NewImportEmployee open={viewEmployeeRegistration.openModalImport} viewEmployeeRegistration={viewEmployeeRegistration} />
    </div >

  );
};

export default CustomCard;

const styles = {
  Card: {
    borderRadius: '20px',
    boxShadow: '4px 8px 6px #e7e8ec',
    border: '0px solid #f7f7f7'
  }
  ,
  Box: {
    // backgroundColor: '#5aca5e',
    width: '100%',
    paddingBottom: '100%', // Isso faz a altura ser igual à largura
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    position: 'relative',
  },
  BoxIndividual: {
    // backgroundColor: '#5aca5e',
    width: '100%',
    paddingBottom: '32%', // Isso faz a altura ser igual à largura
    // display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    position: 'relative',
    marginTop: 47,
    backgroundColor: '#e6e6e6',
    position: 'relative'
  },
  BoxImport: {
    // backgroundColor: '#5aca5e',
    width: '100%',
    paddingBottom: '32%', // Isso faz a altura ser igual à largura
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    position: 'relative',
    marginTop: 5,
    backgroundColor: '#d7d7d7',
    position: 'relative'
  },
  TextBox: {
    fontSize: '50px',
    fontWeight: 'bold',
    fontFamily: 'montserrat',
    color: 'white',
    position: 'absolute', // Posiciona o conteúdo no centro do Box
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  div: {
    marginLeft: 5,
    marginTop: 10
  },
  customButtonStyle: {
    borderWidth: '1px', // Largura da borda
    borderStyle: 'solid', // Estilo da borda
    borderRadius: '20px', // Bordas arredondadas
    textTransform: 'none', // Mantém a capitalização do texto como está
    width: '100%',
    display: 'flex', // Necessário para usar justifyContent
  },
  customIconStyle: {
    position: 'absolute', // Posiciona o ícone absolutamente dentro do Box
    top: '10px', // Posiciona o ícone 10px a partir do topo do Box
    right: '10px', // Posiciona o ícone 10px a partir da direita do Box
    width: 35,
    height: 35,
  },
  circleStyle: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)', // Fundo branco para o ícone
    borderRadius: '50%', // Faz o fundo do ícone ser um círculo
    display: 'flex', // Necessário para centralizar o ícone
    justifyContent: 'center', // Centraliza o ícone horizontalmente
    alignItems: 'center', // Centraliza o ícone verticalmente
  },
  divCadastro: {
    color: '#484fdb',
    fontWeight: 'bold',
    fontFamily: 'montserrat'
  },
  TypographyCadastro: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 17
  },
  ButtonIndividual: {
    color: '#314158',
    marginRight: '10px',
    width: '100%',
    textTransform: 'none',
    backgroundColor: '#e6e6e6',
    fontWeight: 'bold',
    fontFamily: 'montserrat',
    // borderRadius: 10,
    display: 'flex', // Adicione esta linha
    border: 'none', // Adicione esta linha
    fontSize: 15,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  Import: {
    color: '#314158',
    width: '100%',
    textTransform: 'none',
    backgroundColor: '#d7d7d7',
    fontWeight: 'bold',
    fontFamily: 'montserrat',
    // borderRadius: 10,
    marginTop: 5,
    border: 'none',
    fontSize: 15,
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }

}